module.exports = __webpack_public_path__ + "static/media/vampire_sword.9457ec14.png";